import { green, orange, red } from '@ant-design/colors';
import type { ApiResponseStatus } from '@/std/api/types';

export type UploadedFile = {
    id: string;
    file: File;
    status: 'aguardando' | ApiResponseStatus;
    msg: string;
};

export const StatusColors = {
    aguardando: orange.primary,
    erro: red.primary,
    sucesso: green.primary,
};
